import { AssetSvg } from '@/components/foundation/Svg'
import { useMaybeModule, useModules } from '@/hooks/useModule'
import { useTranslator } from '@/hooks/useTranslator'
import { formatMode } from '@/util/modules'
import { classes } from '@lc/libreact'
import { safeProp } from '@lc/libutils'
import { useLayoutEffect, useRef } from 'react'
import { Link } from 'wouter'
import { Translation } from '../foundation/Translation'
import styles from './ModuleSelector.scss'

export function ModuleSelector() {
	const navRef = useRef<HTMLUListElement>(null)

	const modules = useModules()
	const activeModule = useMaybeModule()
	const translator = useTranslator()

	const actualAvailableModules = Object.values(modules).filter(module => {
		return module.mode === activeModule?.mode
	})

	let activeIndex = -1
	if (actualAvailableModules && activeModule) {
		const actualModule = actualAvailableModules.find(
			module => module.path === activeModule.path,
		)
		if (actualModule) {
			const index = actualAvailableModules.indexOf(actualModule)
			activeIndex = index
		}
	}

	useLayoutEffect(() => {
		const nav = navRef.current

		if (!activeModule) return

		if (nav && activeIndex >= 0) {
			const items = nav.children

			if (items.length > 0) {
				const currentItem = items[+activeIndex] as HTMLElement
				if (!currentItem) return
				const left =
					currentItem.offsetLeft + currentItem.offsetWidth / 2

				const x = document.querySelector<SVGSVGElement>(
					'.' + styles.menuModuleShape,
				)

				if (!x) return
				x.style.transform = `translateX(${left}px)`
				return () => {
					x.style.transition = `transform 0.3s ease, width 0.3s ease`
				}
			}
		}
	}, [activeIndex, activeModule])

	if (!activeModule) return null

	if (modules.filter(({ mode }) => mode === activeModule.mode).length < 2)
		return null

	return (
		<nav className={styles.container}>
			<ul className={styles.menuModule} ref={navRef}>
				{modules
					.filter(({ mode }) => mode === activeModule.mode)
					.map(({ module, path }) => (
						<li
							key={path}
							className={styles.moduleListItem}
							aria-label={translator.translate(
								`module:${safeProp(module)}`,
							)}
						>
							<Link
								href={path}
								className={classes(
									styles.menuModuleItem,
									[
										styles.menuModuleItemSelected,
										activeModule.module === module,
									],
									[
										styles.menuModuleItemNonSelected,
										activeModule.module !== module,
									],
								)}
							>
								<AssetSvg
									name={`assets/Module${formatMode(safeProp(module))}.svg`}
									className={classes(
										[
											styles.menuModuleSelectedPicto,
											activeModule.module === module,
										],
										styles.menuModulePicto,
									)}
								/>
								<Translation id={`module:${module}`} as="p" />
							</Link>
						</li>
					))}
			</ul>
			<AssetSvg
				name={'assets/MobileMenuModuleForm.svg'}
				className={styles.menuModuleShape}
			/>
		</nav>
	)
}
